import AdminConsolePage from "@app/pages/admin/admin-console-page";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";

// Hidden staff console. Not linked from anywhere in the app.
export const Route = createFileRoute("/ops-console-7x2k")({
  head: () => pageHead("Staff console"),
  component: AdminConsolePage,
});
